import XImage from '@/components/@base/x-image';

import imagesList from '@/constant/images-list';
import { pageLevelLocalization } from '@/constant/localization';

import GuaranteeIcon from '~/images/icons/guarantee';

const {
  content: {
    aboutUs: { benefits: benfitsLocalization },
  },
} = pageLevelLocalization;

const benefitsData = [
  {
    iconName: <XImage src={imagesList.icons.eyeWithSquareIcon} alt='return guarantee' />,
    title: { color: 'text-[#C08126]', text: '6' },
    subTitle: { color: 'text-[#C08126]', text: benfitsLocalization.firstCard.subtitle },
    description: { color: 'text-[#998364]', text: benfitsLocalization.firstCard.description },
  },
  {
    iconName: <XImage src={imagesList.icons.updater} alt='updater' />,
    title: { color: 'text-[#487598]', text: benfitsLocalization.secondCard.title },
    subTitle: { color: 'text-[#487598]', text: benfitsLocalization.secondCard.subtitle },
    description: { color: 'text-[#617380]', text: benfitsLocalization.secondCard.description },
  },
  {
    iconName: <GuaranteeIcon color='#FF6437' width='52' height='45' />,
    title: { color: 'text-[#BF5A54]', text: benfitsLocalization.thirdCard.title },
    subTitle: { color: 'text-[#BF5A54]', text: benfitsLocalization.thirdCard.subtitle },
    description: { color: 'text-[#836968]', text: benfitsLocalization.thirdCard.description },
  },
];

export default benefitsData;
